module.exports = __webpack_public_path__ + "static/media/oip.569cb304.png";